import React from "react";
import { VideoPlayerOne } from "../VideoPlayers/VideoPlayerOne";
import chooseBg from "../../assets/img/choose/guidance_background.jpg";
import chooseLeftBg from "../../assets/img/choose/guidance_left_bg.png";

export const ChooseAreaOne = () => {
  const list = [
    "QuickBooks Online: a common choice for Canadian small businesses and bookkeepers.",
    "Xero: clean and simple, and connects with apps like Stripe and Shopify.",
    "Wave: has a free starter plan that can suit very simple, low-volume businesses.",
  ];

  return (
    <section
      className="choose-area jarallax choose-bg"
      style={{ backgroundImage: `url(${chooseBg})` }}
    >
      <div className="choose-shape">
        <img
          src={chooseLeftBg}
          alt=""
          data-aos="fade-right"
          data-aos-delay="0"
        />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="choose-content">
              <div className="section-title-two white-title mb-20 tg-heading-subheading animation-style3">
                <h2 className="title tg-element-title">
                Which Accounting Software Should a Startup Use?
                </h2>
              </div>
              <p>
              For most Canadian startups, QuickBooks Online or Xero is the best choice. Both connect to your bank, track GST and PST, and let your bookkeeper work 
              in the same file as you. Not sure which fits? We'll recommend one in your free health check.
              </p>

              <VideoPlayerOne
                src="https://www.youtube.com/embed/XMWYZ-uZjnQ"
                text="Get a Software Recommendation"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="skill-wrap wow fadeInRight" data-wow-delay=".2s">
              <div className="section-title-two mb-15">
                <span className="sub-title">Quick Comparison</span>
                <h2 className="title">
                QuickBooks Online vs Xero vs Wave
                </h2>
              </div>
              <p>
              Pick one, set it up properly, and stick with it. Switching later takes time.
              </p>
              <div className="about-list-two">
                <ul className="list-wrap">
                  {list.map((item, idx) => (
                    <li key={idx}>
                      <i className="fas fa-arrow-right"></i> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
